export default "__VITE_ASSET__DgIBxKiW__"